<template>
  <Modal title="审核" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="deliveryInfo"  :model='deliveryInfo' label-position="right" :label-width="120" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="状态" prop="status">
            <RadioGroup v-model="deliveryInfo.status">
              <Radio :label="1" class="radio">审核通过</Radio>
              <Radio :label="2">拒绝</Radio>
            </RadioGroup>
          </form-item>
          <form-item label="拒绝理由" prop="logistics_no"  v-if="deliveryInfo.status==2">
            <Input placeholder="请输入" v-model="deliveryInfo.remark"></Input>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('deliveryInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { confirms } from '@/api/withdraw'
export default {
  name: 'orderEdit',
  props: ['editShow', 'id'],
  data () {
    return {
      isShow: false,
      order_id: 0,
      deliveryInfo: {
        withdraw_id: 0,
        status: 1,
        remark: ''
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    editShow (val) {
      this.isShow = val
    },
    id (val) {
      this.deliveryInfo.withdraw_id = val
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel', false)
    },
    handleOk (name) {
      if (this.deliveryInfo.status === 2 && (this.deliveryInfo.remark === '' || this.deliveryInfo.remark === null)) {
        this.$Message.error('拒绝理由必填')
        return
      }
      // console.log(this.deliveryInfo)
      // return
      this.$refs[name].validate(valid => {
        if (valid) {
          confirms(this.deliveryInfo).then(res => {
            let msg = '更改成功'
            this.$Message.success(msg)
          }).catch(res => {
            this.$Message.error(res.msg)
          })
          this.$emit('updateStatusModel', false)
        }
      })
    }
  }
}
</script>
